import React, { useEffect, useState } from "react";
import MetaSetup from "./MetaSetup";
import { useBreadcrumbs } from '../../context/BreadcrumbContext';
import type { TabsProps } from 'antd';
import coreAPIService from "../../apiServices/coreAPIService";
import { CTW_API_ENDPOINT } from "../../utils";
import { SetupStatusApiResponse, Connectors, FbPageListRes, AdAccountRes, FbPage, AdAccount, ClientDetails } from "../../interfaces/setup";
import { ConfigProvider, Tabs } from "antd";
import CommonLayout from "../../common/LayoutBlock";
import MetaSetupSkeleton from "../../loaders/MetaSetupSkeleton";
import { useMetaSetup } from "../../context/MetaSetupContext";
import '../../assets/css/tab.css'

const AccountSetup: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const [connectionData, setConnectionData] = useState<Connectors | null>(null)
  // const [metaConnectStatus, setMetaConnectStatus] = useState(0)
  const [loading, setLoading] = useState(true);
  const [adAccountList, setAdAccountList] = useState<AdAccount[]>([])
  const [fbPageList, setFbPageList] = useState<FbPage[]>([])
  const [wabaNumberList, setWabaNumberList] = useState<ClientDetails[]>([])
  const { metaConnectStatus, setMetaConnectStatus } = useMetaSetup();


  useEffect(() => {
    // You can update breadcrumbs here
    setBreadcrumbs([
      {
        title: <div className="text-lg" >Setup</div>,
      },
    ]);
  }, [setBreadcrumbs]);

  useEffect(() => {
    setupStatusCheck();
  }, [metaConnectStatus]);


  const setupStatusCheck = async () => {
    try {
      const clients = localStorage.getItem("waba")
      if (clients) setWabaNumberList(JSON.parse(clients));
      const result = await coreAPIService.get<SetupStatusApiResponse>(CTW_API_ENDPOINT, 'v2/org/connection-status');
      if (result?.meta?.code === 200) {
        setConnectionData(result.data)
        if (result?.data?.metaConnectedStatus) {
          setMetaConnectStatus(true)

          // Fetch ad accounts and FB pages in parallel
          const [resultAdAccount, resultFbPage] = await Promise.all([
            coreAPIService.get<AdAccountRes>(CTW_API_ENDPOINT, 'v2/meta-integration/get-all-ad-accounts'),
            coreAPIService.get<FbPageListRes>(CTW_API_ENDPOINT, 'v2/meta-integration/get-all-fb-pages')
          ]);

          if (resultAdAccount?.meta?.code === 200) {
            setAdAccountList(resultAdAccount.data);
          }
          if (resultFbPage?.meta?.code === 200) {
            setFbPageList(resultFbPage.data);
          }
        }

      } else {
        setConnectionData(null)
        localStorage.removeItem("selectedAdAccount")
        localStorage.removeItem("selectedFbPage")
        localStorage.removeItem("selectedWaba")
      }
      setLoading(false);
    } catch (err) {
      setConnectionData(null);
      // setError("Failed to load data");
      // toast("error", "Error loading meta account details")
      setLoading(false);
    }
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Facebook Ads',
      children: loading ? <div className="p-4 bg-gray-50"><MetaSetupSkeleton /></div> : <div className="p-4 bg-gray-50"><MetaSetup setConnectionData={setConnectionData} metaConnectStatus={metaConnectStatus} setMetaConnectStatus={setMetaConnectStatus} connectionData={connectionData} metaData={{ fbPageList, adAccountList, wabaNumberList }} setupStatusCheck={setupStatusCheck} /></div>,
    },
    {
      key: '2',
      label: 'Google Ads',
      children: <div className="h-[500px] content-center p-4 bg-gray-50 "><img className="m-auto w-40" src="underconstruction.png" alt="underconstruction"></img></div>,
    },
  ];


  return (<>
    {/* {tab === "1" && <>{loading ? <Block><Skeleton.Node active className="px-10 py-2 " style={skeletonBlockStyle} />  </Block> : <MetaProgress progress={metaConnectStatus} />}</>} */}
    {/* {tab === "2" && <><Block><Heading title="Ad Account Setup"/><div className="h-[200px] content-center text-center">Integration under process...</div></Block></>} */}
    <CommonLayout>
      <Tabs
        type="card"
        size="large"
        items={items}
        defaultActiveKey="1"
      />
    </CommonLayout>
  </>
  );
};

export default AccountSetup;
